// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file bffuser/v1/setting_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import { SettingService } from "./setting_service_pb";

/**
 * GetPersonalSettings returns the personal settings for the current member
 * (derived from eauth session).
 *
 * @generated from rpc bffuser.v1.SettingService.GetPersonalSettings
 */
export const getPersonalSettings = SettingService.method.getPersonalSettings;

/**
 * UpdatePersonalSettings applies an update to the personal settings.
 * update_mask.paths lists the fields the user just edited; the backend
 * usecase writes only those columns. Today the client must still populate
 * every field on settings (= PersonalSettings carries strict protovalidate
 * rules); see PersonalSettings comment in setting_model.proto and TODO(#556)
 * for the planned migration to true partial payload. The BFF handler
 * passes the update_mask through to the backend without reconstruction.
 *
 * @generated from rpc bffuser.v1.SettingService.UpdatePersonalSettings
 */
export const updatePersonalSettings = SettingService.method.updatePersonalSettings;
